import { z } from 'zod';

export const CavernsDirectionSchema = z.enum(['NORTH','SOUTH','EAST','WEST','UP','DOWN']);

export type CavernsDirectionType = `${z.infer<typeof CavernsDirectionSchema>}`

export default CavernsDirectionSchema;
